import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const SiteLayout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-ivory text-temple" data-testid="site-root">
      {/* Brand duotone SVG filter — mounted once, referenced by .duotone class.
          Maps grayscale to a 3-stop ramp:
            black  → Temple Black  #161310 (0.086, 0.075, 0.063)
            mid    → Sacred Gold   #A9802F (0.663, 0.502, 0.184)   [whisper]
            white  → Ivory         #F4EEE3 (0.957, 0.933, 0.890)
      */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
        style={{ position: "absolute", width: 0, height: 0, overflow: "hidden" }}
      >
        <defs>
          <filter id="duotone-brand" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.299 0.587 0.114 0 0
                      0.299 0.587 0.114 0 0
                      0.299 0.587 0.114 0 0
                      0     0     0     1 0"
            />
            <feComponentTransfer>
              <feFuncR type="table" tableValues="0.086 0.663 0.957" />
              <feFuncG type="table" tableValues="0.075 0.502 0.933" />
              <feFuncB type="table" tableValues="0.063 0.184 0.890" />
            </feComponentTransfer>
          </filter>
        </defs>
      </svg>

      <Header />
      <main className="flex-1" data-testid="site-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default SiteLayout;
